import React, { useContext, useState, useEffect, useRef } from 'react';
import { ProductContext } from './ProductContext';
import './HamburgerMenu.css';

const HamburgerMenu = () => {
  const { products, setSelectedProductId, selectedProduct } = useContext(ProductContext);
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  const groupedByCategory = products.reduce((acc, product) => {
    const category = product.p_category || 'Other';
    if (!acc[category]) acc[category] = [];
    acc[category].push(product);
    return acc;
  }, {});

  const handleProductClick = (product) => {
    setSelectedProductId(product.p_Id);  // Update the selected product ID
    setMenuOpen(false);  // Close the menu after selecting a product
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="hamburger-wrapper" ref={menuRef}>
      {/* Hamburger icon */}
      <button className="hamburger-icon" onClick={() => setMenuOpen(!menuOpen)}>
        ☰
      </button>

      {/* Show selected product name */}
      {selectedProduct && (
        <span className="selected-product-name">
          {selectedProduct.p_Name}
        </span>
      )}

      {/* Dropdown with grouped products */}
      {menuOpen && (
        <div className="dropdown-menu show">
          {Object.entries(groupedByCategory).map(([category, items]) => (
            <div key={category}>
              <div className="dropdown-category">{category}</div>
              <ul className="dropdown-products">
                {items.map((product) => (
                  <li
                    key={product.p_Id}
                    className="dropdown-product"
                    onClick={() => handleProductClick(product)}  // Set selected product ID
                  >
                    {product.p_Name}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default HamburgerMenu;
